import React, { useState } from 'react';
import { TextField, InputAdornment, IconButton, Tooltip } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

// Champ mot de passe avec bouton pour afficher / masquer la saisie
const PasswordField = ({ label = 'Mot de passe', InputProps, ...props }) => {
  const [visible, setVisible] = useState(false);
  const toggleLabel = visible ? 'Masquer le mot de passe' : 'Afficher le mot de passe';

  return (
    <TextField
      fullWidth
      label={label}
      {...props}
      type={visible ? 'text' : 'password'}
      InputProps={{
        ...InputProps,
        endAdornment: (
          <InputAdornment position="end">
            <Tooltip title={toggleLabel}>
              <IconButton
                aria-label={toggleLabel}
                onClick={() => setVisible((v) => !v)}
                onMouseDown={(e) => e.preventDefault()}
                edge="end"
              >
                {visible ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </Tooltip>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default PasswordField;
